import { Flex } from "@jewlr/storybook/core"
import styled from "styled-components"

export const ItemDetailsList = styled.ul`
  list-style: disc;
  margin: 0;
  padding-left: 24px;
  ${(props) => props.theme.mediaQueries.tablet`
    list-style: none;
    padding: 0;
  `}
`

export const ItemContainer = styled(Flex).attrs({
  flexDirection: { _: "column", tablet: "row" },
  mb: "12px",
  px: { tablet: 2 },
})``

export const getStep = (customer_progress) => {
  let progress = -1

  switch (customer_progress) {
    case "customer_new":
      progress = 0
      break
    case "manufacturing":
    case "detailing":
      progress = 1
      break
    case "qc":
    case "final":
      progress = 2
      break
    case "ready_to_ship":
      progress = 3
      break
    case "customer_shipped":
      progress = 4
      break
    default:
      break
  }
  return progress
}

export const progressLabels = [
  { name: "Order Received" },
  { name: "In Production" },
  { name: "Quality Control" },
  { name: "Ready to Ship", width: "36px" },
  { name: "Shipped" },
]
